export const colorClasses = {
  neutral: {
    checkedBg:
      'bg-neutral-100 hover:bg-neutral-200 focus:bg-neutral-200 focus:!outline focus:!outline-2 focus:!outline-neutral-100',
    disabledBg: 'bg-neutral-50',
    disabledDotBg: 'bg-neutral-100'
  },
  primary: {
    checkedBg:
      'bg-primary-100 hover:bg-primary-200 focus:bg-primary-200 focus:!outline focus:!outline-2 focus:!outline-[#CBF0FD]',
    disabledBg: 'bg-primary-50',
    disabledDotBg: 'bg-primary-100'
  },
  success: {
    checkedBg:
      'bg-success-100 hover:bg-success-200 focus:bg-success-200 focus:!outline focus:!outline-2 focus:!outline-success-100',
    disabledBg: 'bg-success-50',
    disabledDotBg: 'bg-success-100'
  },
  warning: {
    checkedBg:
      'bg-warning-100 hover:bg-warning-200 focus:bg-warning-200 focus:!outline focus:!outline-2 focus:!outline-warning-100',
    disabledBg: 'bg-warning-50',
    disabledDotBg: 'bg-warning-100'
  },
  danger: {
    checkedBg:
      'bg-danger-100 hover:bg-danger-200 focus:bg-danger-200 focus:!outline focus:!outline-2 focus:!outline-danger-100',
    disabledBg: 'bg-danger-50',
    disabledDotBg: 'bg-danger-100'
  }
};

export const switchSizes = {
  small: {
    width: 24,
    height: 14,
    dotSize: 10,
    translateChecked: 10
  },
  medium: {
    width: 28,
    height: 16,
    dotSize: 12,
    translateChecked: 12
  },
  large: {
    width: 32,
    height: 18,
    dotSize: 12,
    translateChecked: 16
  }
};

/**
 * Generates class names for the Switch component based on its state.
 */
export const getSwitchClasses = ({ checked, disabled, color, size, hasCustomColor }) => {
  const colorData = colorClasses[color] || colorClasses.primary;
  const dimensions = switchSizes[size] || switchSizes.small;

  const buttonClasses = [
    // Base classes
    'flex cursor-pointer items-center rounded-full border border-solid border-neutral-300 px-[1px] !outline-2 !outline-neutral-100 focus-within:!outline',
    // Size classes
    `w-[${dimensions.width}px] min-w-[${dimensions.width}px] h-[${dimensions.height}px]`,
    // State-based classes
    checked && '!border-transparent !outline-primary-100 focus-within:!bg-primary-100',
    disabled && 'border-neutral-75 bg-neutral-50 opacity-75',
    // Handle background when not using custom colors
    !hasCustomColor && [
      !checked && !disabled && 'bg-neutral-100 focus-within:bg-neutral-200 hover:bg-neutral-200',
      checked && !disabled && colorData.checkedBg
    ],
    // State-specific overrides
    !checked && disabled && '!cursor-not-allowed bg-neutral-50',
    checked && disabled && `!cursor-not-allowed ${colorData.disabledBg}`
  ];

  const knobClasses = [
    'rounded-full duration-200',
    !checked && !disabled && 'bg-neutral-500',
    !checked && disabled && 'bg-neutral-200',
    checked && !disabled && `bg-${color}-500`,
    checked && disabled && colorData.disabledDotBg
  ];

  return {
    button: buttonClasses,
    knob: knobClasses,
    dimensions
  };
};

export const getLabelClasses = ({ disabled }) => {
  return ['block pb-1 text-sm font-500', disabled ? 'text-neutral-400' : 'text-neutral-800'];
};
